import { useEffect } from "react";

export function usePageMetadata(title: string, description: string, image?: string): void {
  useEffect(() => {
    const previousTitle = document.title;
    const changes: Array<{ meta: HTMLMetaElement; previous?: string; created: boolean }> = [];

    function setMeta(attribute: "name" | "property", key: string, content: string) {
      let meta = document.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
      const created = !meta;
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute(attribute, key);
        document.head.append(meta);
      }
      changes.push({ meta, previous: meta.getAttribute("content") ?? undefined, created });
      meta.content = content;
    }

    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", window.location.href);
    setMeta("property", "og:image", image || new URL("/icons/icon-512.png", window.location.origin).href);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    return () => {
      document.title = previousTitle;
      for (const change of changes) {
        if (change.created) change.meta.remove();
        else if (change.previous !== undefined) change.meta.content = change.previous;
      }
    };
  }, [description, image, title]);
}
